module.exports = __webpack_public_path__ + "media/images/blue_purple_lanterns-5dbd1e3cac4dc7a12c821414f95b8a48.png";